import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Custom validator for year fields.
 * Ensures the value is all lowercase, has no whitespace, no special characters, and is unique.
 * @returns Validator function that checks the control value.
 */
export function yearValidator(years: number[]): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (!value) {
      return { required: true };
    }
    // Check for no whitespaces
    if (/\s/.test(value)) {
      return { whitespaceNotAllowed: true };
    }

    // Check for no special characters (only allow alphanumeric)
    if (/[^0-9]/.test(value)) {
      return { noAlphanumericAllowed: true };
    }

    // no double
    if (years.includes(value) || years.includes(Number(value))) {
      return { notUnique: true };
    }

    // no double
    if (value.toString().length > 4 || value.toString().length < 4) {
      return { yearLength: true };
    }

    return null; // If all checks pass, return null (no errors)
  };
}
